import { Box, makeStyles } from "@material-ui/core"
import { FiberManualRecord } from "@material-ui/icons"
import React from "react"
import { RowBox } from ".."

const useStyles = makeStyles(() => ({
  chartLegendLabel: {
    fontSize: 11,
  },
  chartLegendDot: {
    fontSize: 15,
  },
}))

const HorizontalLegend = ({ children, mb = 1, mt, ...props }) => (
  <RowBox mb={mb} mt={mt} {...props} justifyContent="flex-end" mr={2}>
    {children}
  </RowBox>
)

const HorizontalLegendItem = ({ text, className }) => {
  const classes = useStyles()

  return (
    <RowBox py={0.5} px={1}>
      <FiberManualRecord className={`${classes.chartLegendDot} ${className}`} />
      <Box ml={0.5} className={classes.chartLegendLabel}>
        {text}
      </Box>
    </RowBox>
  )
}

export { HorizontalLegend, HorizontalLegendItem }
